<div class="border-top" [ngClass]="label === 'Computational time this month' || label === 'Storage space' ? 'py-3' : 'py-2'">
    <div class="label-text">{{ label }}</div>
    <ng-content></ng-content>
</div>
